module.exports = (__parcel__import__("khNJU")).then(() => parcelRequire('4MKVl'));